export default __webpack_public_path__ + "static/two_body_2_v2-cd386678b10ddbb9c112cae5b8def365.png";